import { BoundingBox } from '../../../types/syntiro_honey';

/** Reads the anchored bbox from a record's extraction payload, or null. */
export function readBoundingBox(rawPayload: Record<string, unknown>): BoundingBox | null {
  const bbox = rawPayload.bbox;
  if (typeof bbox !== 'object' || bbox === null) {
    return null;
  }
  const { page, x, y, width, height } = bbox as Record<string, unknown>;
  if (
    typeof page === 'number' &&
    typeof x === 'number' &&
    typeof y === 'number' &&
    typeof width === 'number' &&
    typeof height === 'number'
  ) {
    return { page, x, y, width, height };
  }
  return null;
}
